module.exports = __webpack_public_path__ + "0e89d1483b8da7979f99399277e0fa3b.png";